import {
  paymentMethodsByCountry,
  paymentMethodsByCountryForMultipleInvoices,
  type Country,
} from '../entities/Country';
import { featuresKey } from '../entities/Feature';
import type { UseCase } from '../entities/enums';

interface AvailablePaymentMethods {
  country: Country;
  features: string[];
  invoiceOnly?: boolean;
  isCpqa?: boolean;
  isCajaUpsell?: boolean;
  useCase: UseCase;
  isMultipleInvoice?: boolean;
}

export function getAvailablePaymentMethods({
  country,
  features,
  invoiceOnly,
  isCpqa,
  isCajaUpsell,
  useCase,
  isMultipleInvoice,
}: AvailablePaymentMethods): string[] {
  if (invoiceOnly || isCpqa) {
    return ['Invoice'];
  }

  if (useCase === 'INVOICE' && isMultipleInvoice) {
    return paymentMethodsByCountryForMultipleInvoices[country];
  }

  return paymentMethodsByCountry[country].filter((paymentMethod) => {
    switch (country) {
      case 'MY':
        if (
          (features.includes(featuresKey.hidePayInvoiceMY) &&
            features.includes(featuresKey.toggleHidePayByInvoice) &&
            paymentMethod === 'Invoice' &&
            !isCajaUpsell) ||
          (paymentMethod === 'Invoice' && useCase === 'INVOICE')
        ) {
          return false;
        }

        return true;

      case 'SG':
        if (
          (features.includes(featuresKey.hidePayInvoiceSG) &&
            features.includes(featuresKey.toggleHidePayByInvoice) &&
            paymentMethod === 'Invoice' &&
            !isCajaUpsell) ||
          (paymentMethod === 'Invoice' && useCase === 'INVOICE')
        ) {
          return false;
        }

        return true;

      case 'PH':
        if (
          !features.includes(featuresKey.showPHBnpl) &&
          paymentMethod === 'PhBnpl'
        ) {
          return false;
        }

        if (
          (features.includes(featuresKey.hidePayInvoicePH) &&
            features.includes(featuresKey.toggleHidePayByInvoice) &&
            paymentMethod === 'Invoice' &&
            !isCajaUpsell) ||
          (paymentMethod === 'Invoice' && useCase === 'INVOICE')
        ) {
          return false;
        }

        return true;

      case 'HK':
        if (
          (features.includes(featuresKey.hidePayInvoiceHK) &&
            features.includes(featuresKey.toggleHidePayByInvoice) &&
            paymentMethod === 'Invoice' &&
            !isCajaUpsell) ||
          (paymentMethod === 'Invoice' && useCase === 'INVOICE')
        ) {
          return false;
        }

        return true;

      case 'ID':
        if (useCase !== 'INVOICE' && paymentMethod === 'IdVirtualAccount') {
          return false;
        }

        if (
          !features.includes(featuresKey.showIDOnlineBanking) &&
          paymentMethod === 'IdOnlineBanking'
        ) {
          return false;
        }

        if (
          (features.includes(featuresKey.hidePayInvoiceID) &&
            features.includes(featuresKey.toggleHidePayByInvoice) &&
            paymentMethod === 'Invoice' &&
            !isCajaUpsell) ||
          (paymentMethod === 'Invoice' && useCase === 'INVOICE')
        ) {
          return false;
        }

        return true;

      case 'TH':
        if (
          (features.includes(featuresKey.hidePayInvoiceTH) &&
            features.includes(featuresKey.toggleHidePayByInvoice) &&
            paymentMethod === 'Invoice' &&
            !isCajaUpsell) ||
          (paymentMethod === 'Invoice' && useCase === 'INVOICE')
        ) {
          return false;
        }

        return true;

      case 'NZ':
        if (
          (features.includes(featuresKey.hidePayInvoiceNZ) &&
            features.includes(featuresKey.toggleHidePayByInvoice) &&
            paymentMethod === 'Invoice' &&
            !isCajaUpsell) ||
          (paymentMethod === 'Invoice' && useCase === 'INVOICE')
        ) {
          return false;
        }

        return true;

      case 'AU':
        if (
          (features.includes(featuresKey.hidePayInvoiceAU) &&
            features.includes(featuresKey.toggleHidePayByInvoice) &&
            paymentMethod === 'Invoice' &&
            !isCajaUpsell) ||
          (paymentMethod === 'Invoice' && useCase === 'INVOICE')
        ) {
          return false;
        }

        return true;

      default:
        return paymentMethod;
    }
  });
}
